import {dataURIToImage} from "./confetti-shapes.ts";
import blueConfettiPNG from "./images/blue-confetti.png?inline";
import bluePlanetConfettiPNG from "./images/blue-planet-confetti.png?inline";
import blueStarCutOutConfettiPNG from "./images/blue-star-cut-out-confetti.png?inline";
import greenConfettiPNG from "./images/green-confetti.png?inline";
import greenPlanetConfettiPNG from "./images/green-planet-confetti.png?inline";
import orangePlanetConfettiPNG from "./images/orange-planet-confetti.png?inline";
import orangeScribbleStarCutOutConfettiPNG from "./images/orange-scribble-star-cut-out-confetti.png?inline";
import orangeStarConfettiPNG from "./images/orange-star-confetti.png?inline";
import redConfettiPNG from "./images/red-confetti.png?inline";
import springConfettiPNG from "./images/spring-confetti.png?inline";
import whiteAsteriskConfettiPNG from "./images/white-asterisk-confetti.png?inline";
import whiteOrangeStarCutOutConfettiPNG from "./images/white-orange-star-cut-out-confetti.png?inline";
import yellowConfettiPNG from "./images/yellow-confetti.png?inline";
import yellowStarConfettiPNG from "./images/yellow-star-confetti.png?inline";

interface ConfettiShape {
    front: HTMLImageElement;
    back: HTMLImageElement;
}

// Shapes must have a front and back even though we aren't currently using the
// twist prop
export const defaultShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(blueConfettiPNG),
        back: dataURIToImage(blueConfettiPNG),
    },
    {
        front: dataURIToImage(greenConfettiPNG),
        back: dataURIToImage(greenConfettiPNG),
    },
    {
        front: dataURIToImage(redConfettiPNG),
        back: dataURIToImage(redConfettiPNG),
    },
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(yellowConfettiPNG),
        back: dataURIToImage(yellowConfettiPNG),
    },
];

const warmColorShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(redConfettiPNG),
        back: dataURIToImage(redConfettiPNG),
    },
    {
        front: dataURIToImage(yellowConfettiPNG),
        back: dataURIToImage(yellowConfettiPNG),
    },
    {
        front: dataURIToImage(yellowConfettiPNG),
        back: dataURIToImage(yellowConfettiPNG),
    },
    {
        front: dataURIToImage(yellowConfettiPNG),
        back: dataURIToImage(yellowConfettiPNG),
    },
];

const coolColorShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(blueConfettiPNG),
        back: dataURIToImage(blueConfettiPNG),
    },
    {
        front: dataURIToImage(greenConfettiPNG),
        back: dataURIToImage(greenConfettiPNG),
    },
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
];

const yellowShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(yellowStarConfettiPNG),
        back: dataURIToImage(yellowStarConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(yellowStarConfettiPNG),
        back: dataURIToImage(yellowStarConfettiPNG),
    },
    {
        front: dataURIToImage(yellowConfettiPNG),
        back: dataURIToImage(yellowConfettiPNG),
    },
    {
        front: dataURIToImage(yellowConfettiPNG),
        back: dataURIToImage(yellowConfettiPNG),
    },
];

const greenShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(greenConfettiPNG),
        back: dataURIToImage(greenConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
    {
        front: dataURIToImage(greenPlanetConfettiPNG),
        back: dataURIToImage(greenPlanetConfettiPNG),
    },
];

const orangeShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
    {
        front: dataURIToImage(orangeStarConfettiPNG),
        back: dataURIToImage(orangeStarConfettiPNG),
    },
    {
        front: dataURIToImage(redConfettiPNG),
        back: dataURIToImage(redConfettiPNG),
    },
    {
        front: dataURIToImage(orangeScribbleStarCutOutConfettiPNG),
        back: dataURIToImage(orangeScribbleStarCutOutConfettiPNG),
    },
];

const blueShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(blueStarCutOutConfettiPNG),
        back: dataURIToImage(blueStarCutOutConfettiPNG),
    },
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
    {
        front: dataURIToImage(blueConfettiPNG),
        back: dataURIToImage(blueConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
];

const planetShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(redConfettiPNG),
        back: dataURIToImage(redConfettiPNG),
    },
    {
        front: dataURIToImage(orangePlanetConfettiPNG),
        back: dataURIToImage(orangePlanetConfettiPNG),
    },
    {
        front: dataURIToImage(bluePlanetConfettiPNG),
        back: dataURIToImage(bluePlanetConfettiPNG),
    },
    {
        front: dataURIToImage(springConfettiPNG),
        back: dataURIToImage(springConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
];

const starShapes: Array<ConfettiShape> = [
    {
        front: dataURIToImage(whiteAsteriskConfettiPNG),
        back: dataURIToImage(whiteAsteriskConfettiPNG),
    },
    {
        front: dataURIToImage(blueStarCutOutConfettiPNG),
        back: dataURIToImage(blueStarCutOutConfettiPNG),
    },
    {
        front: dataURIToImage(whiteOrangeStarCutOutConfettiPNG),
        back: dataURIToImage(whiteOrangeStarCutOutConfettiPNG),
    },
    {
        front: dataURIToImage(orangeScribbleStarCutOutConfettiPNG),
        back: dataURIToImage(orangeScribbleStarCutOutConfettiPNG),
    },
];

// the list has repeats because level 5 and 10
// are bounce celebrations, not confetti.
// this does mean that on random mode, we see a little more
// starShapes and greenShapes
export const shapesList = [
    defaultShapes,
    coolColorShapes,
    warmColorShapes,
    yellowShapes,
    starShapes,
    greenShapes,
    blueShapes,
    orangeShapes,
    planetShapes,
    greenShapes,
    starShapes,
];
